export default function RequiredFlag() {
  return <span className="kup-label-required-flag">*</span>;
}
